/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserConfigEntryView = {
    name?: UserConfigEntryView.name;
    value?: string;
};
export namespace UserConfigEntryView {
    export enum name {
        CONTENT_MASTER_ON_DEMAND_LIMIT = 'content_master_on_demand_limit',
    }
}

